import { excludeForwardProps } from '@gasbi/shared/common/utils/excludeForwardProps';

import { Stack } from '@mui/joy';
import { Chip } from '@mui/joy';
import { styled } from '@mui/joy';

export const StyledActFormHeader = styled(Stack)(({ theme }) => ({
  marginRight: theme.spacing(2),
  marginLeft: theme.spacing(2),
  marginTop: theme.spacing(2),
  padding: theme.spacing(2),
  background: theme.palette.isDarkMode
    ? theme.palette.neutral[200]
    : theme.palette.neutral[50],
  borderRadius: theme.spacing(1),
  flexDirection: 'row',
  gap: theme.spacing(1),
  flexWrap: 'wrap',
}));

export const StyledActFormHeaderChip = styled(Chip, {
  shouldForwardProp: excludeForwardProps('isEditMode'),
})<{ isEditMode?: boolean }>(({ theme, isEditMode }) => ({
  color: isEditMode
    ? theme.palette.neutral[50]
    : theme.palette.isDarkMode
      ? theme.palette.primary[300]
      : theme.palette.primary[700],
  backgroundColor: isEditMode
    ? theme.palette.success[500]
    : theme.palette.isDarkMode
      ? theme.palette.primary[900]
      : theme.palette.primary[50],
}));
